import styled from "styled-components";
import Colors from "../../constants/Colors";

export const Card = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px;
  gap: 16px;
  /* white */

  background: #ffffff;
  border-radius: 12px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;

  -webkit-box-shadow: 0px 0px 14px 1px rgba(49, 49, 49, 0.14);
  box-shadow: 0px 0px 14px 1px rgba(49, 49, 49, 0.14);
`;

export const MedicCardContainer = styled.div`
  display: grid;

  grid-template-columns: 0.5fr 3fr 1fr;
  @media screen and (max-width: 760px) {
    grid-template-columns: 1fr 3fr;
    gap: 10px;
  }
  grid-gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const MedicCardImage = styled.img`
  width: 48px;
  height: 48px;

  border-radius: 50%;
`;

export const ViewAllSchedulingCard = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  font-size: 16px;
  border: none;
  color: #0a5190;
  cursor: pointer;
  width: 100%;
  transition: width 2s, height 2s, transform 2s;
`;

export const DayContainer = styled.div``;

export const TimeContainer = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 4fr;
  grid-gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const HoursContainer = styled.div`
  display: grid;
  @media screen and (max-width: 760px) {
    grid-template-columns: repeat(3, 1fr);
  }
  grid-template-columns: repeat(7, 1fr);

  grid-gap: 10px;
`;

export const HourCard = styled.button`
  display: flex;
  justify-content: center;
  border-radius: 4px;
  text-align: center;
  background: ${Colors.SPM50};

  align-items: center;
  padding: 4px 8px;
  max-height: 30px;
  border: none;
  cursor: pointer;
`;
